import * as React from "react";
import { Component } from "react";
import { Button, Col, ControlLabel, Form, FormControl, FormGroup } from "react-bootstrap";
import "../../../../css/components/projects/project/accounts/companyform.css";
import { ICompanyProps, ICompanyState } from "./interfaces";

export default class CompanyForm extends Component<ICompanyProps, ICompanyState> {
  public constructor(props: ICompanyProps) {
    super(props);

    this.state = {
      loading: true,
    };

    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);

    this.handleNameChanged = this.handleNameChanged.bind(this);
    this.handleAddressChanged = this.handleAddressChanged.bind(this);
    this.handleCityStateChanged = this.handleCityStateChanged.bind(this);
    this.handleFaxChanged = this.handleFaxChanged.bind(this);
    this.handleEmailChanged = this.handleEmailChanged.bind(this);
    this.handlePhoneChanged = this.handlePhoneChanged.bind(this);
    this.handleWebsiteChanged = this.handleWebsiteChanged.bind(this);
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    const labelWidth = 4;
    const inputWidth = 8;
    return (
      <div className="column container-fixed-navbar company-Form-Grid">
        <div className="company-Form">
          <fieldset id="companyInformation">
            <legend>Company Information</legend>
            <Form onSubmit={this.handleSave} horizontal={true}>
              <FormGroup controlId="name">
                <Col componentClass={ControlLabel} sm={labelWidth}>
                  Company Name
                </Col>
                <Col sm={inputWidth}>
                  <FormControl
                    type="text"
                    value={this.props.name}
                    onChange={this.handleNameChanged}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="address">
                <Col componentClass={ControlLabel} sm={labelWidth}>
                  Address
                </Col>
                <Col sm={inputWidth}>
                  <FormControl
                    type="text"
                    value={this.props.address}
                    onChange={this.handleAddressChanged}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="cityState">
                <Col componentClass={ControlLabel} sm={labelWidth}>
                  City, State
                </Col>
                <Col sm={inputWidth}>
                  <FormControl
                    type="text"
                    value={this.props.cityState}
                    onChange={this.handleCityStateChanged}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="email">
                <Col componentClass={ControlLabel} sm={labelWidth}>
                  Email
                </Col>
                <Col sm={inputWidth}>
                  <FormControl
                    type="email"
                    value={this.props.email}
                    onChange={this.handleEmailChanged}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="phone">
                <Col componentClass={ControlLabel} sm={labelWidth}>
                  Phone
                </Col>
                <Col sm={inputWidth}>
                  <FormControl
                    type="text"
                    value={this.props.phone}
                    onChange={this.handlePhoneChanged}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="fax">
                <Col componentClass={ControlLabel} sm={labelWidth}>
                  Fax
                </Col>
                <Col sm={inputWidth}>
                  <FormControl
                    type="text"
                    value={this.props.fax}
                    onChange={this.handleFaxChanged}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="website">
                <Col componentClass={ControlLabel} sm={labelWidth}>
                  Website
                </Col>
                <Col sm={inputWidth}>
                  <FormControl
                    type="website"
                    value={this.props.website}
                    onChange={this.handleWebsiteChanged}
                  />
                </Col>
              </FormGroup>
              <Col smOffset={labelWidth} sm={inputWidth}>
                <Button
                  className="button-right"
                  bsStyle="success"
                  bsSize="small"
                  onClick={this.handleSave}
                >
                  Save
                </Button>
                <Button bsStyle="danger" bsSize="small" onClick={this.handleCancel}>
                  Cancel
                </Button>
              </Col>
            </Form>
          </fieldset>
        </div>
      </div>
    );
  }

  private handleSave(e: any) {
    e.preventDefault();
    this.props.handleSave();
  }
  private handleCancel(e: any) {
    e.preventDefault();
    this.props.handleCancel();
  }

  private handleNameChanged(e: any) {
    this.props.handleNameChanged(e.currentTarget.value);
  }
  private handleAddressChanged(e: any) {
    this.props.handleAddressChanged(e.currentTarget.value);
  }
  private handleCityStateChanged(e: any) {
    this.props.handleCityStateChanged(e.currentTarget.value);
  }
  private handleEmailChanged(e: any) {
    this.props.handleEmailChanged(e.currentTarget.value);
  }
  private handleFaxChanged(e: any) {
    this.props.handleFaxChanged(e.currentTarget.value);
  }
  private handlePhoneChanged(e: any) {
    this.props.handlePhoneChanged(e.currentTarget.value);
  }
  private handleWebsiteChanged(e: any) {
    this.props.handleWebsiteChanged(e.currentTarget.value);
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/accounts/CompanyForm.tsx